import Vue from 'vue';
import * as types from './types';

const mutations = {
  [types.RESET_STATE]() {
    // Object.assign(state, initialState);
  },
  [types.SET_COUNTRIES](state, data) {
    state.countries = data;
  },
  // FETCH_MEDIA
  [types.FETCH_MEDIA_PENDING](state) {
    state.fetchMediaPending = true;
  },
  [types.FETCH_MEDIA_FULFILLED](state) {
    state.fetchMediaPending = false;
  },
  [types.FETCH_MEDIA_ERROR](state) {
    state.fetchMediaPending = false;
  },
  // FETCH_MEDIA
  [types.FETCH_PRESS_RELEASES_FULFILLED](state, data) {
    Vue.set(state, 'pressReleases', data);
  },
  [types.FETCH_MEDIA_REPORTS_FULFILLED](state, data) {
    Vue.set(state, 'mediaReports', data);
  },
  [types.FETCH_MEDIA_KITS_FULFILLED](state, data) {
    Vue.set(state, 'mediaKits', data);
  },
  // FETCH_JOB
  [types.FETCH_JOB_PENDING](state) {
    state.fetchJobPending = true;
  },
  [types.FETCH_JOB_FULFILLED](state) {
    state.fetchJobPending = false;
  },
  [types.FETCH_JOB_ERROR](state) {
    state.fetchJobPending = false;
  },
  // SEND_PROBLEM_REPORT_PENDING
  [types.SEND_PROBLEM_REPORT_PENDING](state) {
    state.sendProblemReportPending = true;
  },
  [types.SEND_PROBLEM_REPORT_FULFILLED](state) {
    state.sendProblemReportPending = false;
  },
  [types.SEND_PROBLEM_REPORT_ERROR](state) {
    state.sendProblemReportPending = false;
  },
  // FETCH_AVAM_OCCUPATION_CLASSIFICATIONS
  [types.FETCH_AVAM_OCCUPATION_CLASSIFICATIONS_PENDING](state) {
    state.fetchAvamOccupationClassificationsPending = true;
  },
  [types.FETCH_AVAM_OCCUPATION_CLASSIFICATIONS_FULFILLED](state, { data }) {
    state.avamOccupationClassifications = data.data;
    state.fetchAvamOccupationClassificationsPending = true;
  },
  [types.FETCH_AVAM_OCCUPATION_CLASSIFICATIONS_ERROR](state) {
    state.fetchAvamOccupationClassificationsPending = true;
  },
};

export default mutations;
